import SelectItem from "../interfaces/SelectItem";

type EventSearchDefaults = {
  categoryId: number;
  defaultTitle?: string;
  defaultKeywords?: string;
  defaultAuthors?: Array<string>;
  categoryName?: string;
  //Added optional product areas properties
  productAreas?: SelectItem[];
};

function validatedEventSearchDefaults(
  eventSearchDefaults: EventSearchDefaults
): EventSearchDefaults | null {
  if (
    eventSearchDefaults &&
    "categoryId" in eventSearchDefaults &&
    typeof eventSearchDefaults.categoryId === "number" &&
    (("defaultTitle" in eventSearchDefaults &&
      typeof eventSearchDefaults.defaultTitle === "string") ||
      ("defaultKeywords" in eventSearchDefaults &&
        typeof eventSearchDefaults.defaultKeywords === "string") ||
      ("defaultAuthors" in eventSearchDefaults &&
        typeof eventSearchDefaults.defaultAuthors === "object" &&
        eventSearchDefaults.defaultAuthors.length > 0) ||
      //Validate product area properties in defaults of category
      validateProductAreaProperties(eventSearchDefaults))
  ) {
    return eventSearchDefaults;
  }

  return null;
}

function validateProductAreaProperties(defaults: EventSearchDefaults): boolean {
  if ("productAreas" in defaults) {
    return (
      typeof defaults.productAreas === "object" &&
      defaults.productAreas.length > 0
    );
  } else {
    return false;
  }
}

export {
  EventSearchDefaults,
  validatedEventSearchDefaults,
  validateProductAreaProperties,
};
